import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { publishProject } from '../project-actions';
import { trackProjectPublish } from '../../support-and-tracking/tracking-functions';
import { useProjectWizardABCTest } from '../../components/hooks/projectWizardAbcTest';

export const START_ORIGIN_PARAM = 'from';

export const START_ORIGINS = {
    LOGIN: 'login',
    MISSING_USER_INFO: 'missing-user-info',
    PUBLISH_BANNER: 'publish-banner',
};

export const PUBLISH_TRIGGERS = {
    BUTTON: 'button',
    CONFIRM_DIALOG: 'confirm-dialog',
    AUTO_START: 'auto-start',
};

export const getProjectStartPath = ({ projectId, startOrigin }) =>
    `/project/${projectId}/start?${START_ORIGIN_PARAM}=${startOrigin}`;

export const usePublishProject = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const projectWizardABCTest = useProjectWizardABCTest();

    return ({ project, trigger, startOrigin }) =>
        dispatch(publishProject({ projectId: project.id, publishedAt: project.profile?.publishedAtOverride })).then(
            () => {
                trackProjectPublish({ project, projectWizardABCTest, trigger, startOrigin });
                navigate(`/project/${project.id}`, { replace: true });
            }
        );
};
